// extracted by mini-css-extract-plugin
export var columnList = "_ee-0";